const acDomain = 'https://ad-a.origin.veyasoft.com'
export default acDomain
